import React, { useEffect, useRef, useState } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    IconButton,
    Typography,
    Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import styless from '../../component/scheduleComps/scheduleList/partList.module.css';
import { AddCircle, Closecircle, UploadImg } from '../../Svg';
import stylesp from './prod.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { addTopcategoriesThunk, getTopCategoriesThunk } from '../../redux/appearanceSlice';
import { toast } from 'react-toastify';







const Categories = ({ Accordions, handleChange, expanded }) => {
    const [selectedCategories, setSelectedCategories] = useState([])
    const { categoryHeirarchy } = useSelector((state) => state.categoryHeirarchy);
    const category = categoryHeirarchy?.categories
    const { categories, refresh } = useSelector((state) => state.appearances)

    const dispatch = useDispatch()



    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const [filteredData, setFilteredData] = useState(null);


    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setIsOpen(false);
        setSearchTerm('');
        setFilteredData(null);
    };

    const handleToggleDropdown = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (!newState) {
            closeDropdown();
        }
    };

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        const filtered = term === ''
            ? null
            : category?.filter(customer =>
                customer?.name?.toLowerCase().includes(term.toLowerCase())
            );
        setFilteredData(filtered);
    };





    const handleSelectionChange = (cat) => {
        setSelectedCategories((prevSelected) => {
            const isSelected = prevSelected?.some((item) => item?._id === cat?._id);
            if (isSelected) {
                return prevSelected?.filter((item) => item?._id !== cat?._id);
            }
            else if (prevSelected?.length > 14) {
                toast.error("You can select up to 14 categories only.");
                return prevSelected;
            }
            else {
                return [...prevSelected, { _id: cat._id, name: cat?.name }];
            }
        });
    };

    const addCategories = async () => {
        const ids = await selectedCategories.map((i) => i?._id)
        dispatch(addTopcategoriesThunk(ids))
    }

    useEffect(() => {
        dispatch(getTopCategoriesThunk())
    }, [refresh])

    useEffect(() => {
        setSelectedCategories(categories?.data)
    }, [categories])

    return (
        <Accordions sx={{ marginBottom: "20px" }}
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography sx={{
                    fontSize: "16px",
                    color: "#1D1F2C",
                }}>Categories</Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px 20px" }}>
                <div>
                    <label className={styles.addCatLabel}>
                        Categories
                    </label>

                    <div className={stylesp.customSelect} ref={dropdownRef}>
                        <div
                            className={styles.addCatSelect} style={{ paddingTop: "11px" }}
                            onClick={handleToggleDropdown}
                        >
                            Select
                        </div>
                        {
                            isOpen &&
                            <div className={stylesp.dropdownContent}>
                                <div style={{}}>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            boxSizing: 'border-box',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px'
                                        }}
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                    {(filteredData || category)?.map((cat) => (

                                        <label
                                            key={cat?._id}
                                            className={stylesp.dropdownItem}
                                        >
                                            {cat?.name}
                                            <input
                                                type="checkbox"
                                                checked={selectedCategories?.some((item) => item?._id === cat?._id)}
                                                onChange={() => handleSelectionChange(cat)}
                                            />
                                        </label>
                                    ))}


                                </div>
                                <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                    <button
                                        type="submit"
                                        className={stylesp.loginButton}
                                        style={{ borderRadius: "0px" }}
                                        onClick={toggleDropdown}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        }
                    </div>


                    <p className={styles.addCatLabel} style={{ margin: "15px 0" }}>You can select category that you want to show upto 14 categories</p>

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 10, gap: 10, }}>
                        {
                            selectedCategories?.map((i) => (
                                <div className={styles.selectedname}>
                                    {i?.name}
                                    <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSelectionChange(i)}>
                                        {Closecircle()}

                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    <div style={{ margin: "10px 0px 10px 0px", display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                        <button className={styless.cancelBtn}>Cancel</button>
                        <button className={styless.submitBtn} onClick={addCategories} disabled={categories?.loading}>{categories?.loading ? 'please wait...' : 'Save changes'}</button>
                    </div>
                </div>
            </AccordionDetails>
        </Accordions>
    )
}

export default Categories